export const endpoints = {
  vectorDocuments: (args) =>
    `/api/ai-mentor/orgs/${args.org}/users/${args.userId}/clean-vector-results/${args.sessionId}/`,
};
